import { CheckCircle, Mail, AlertCircle } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { API_URL } from '../config/api'

export default function VerifyEmail() {
  const [searchParams] = useSearchParams()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')
  

  useEffect(() => {
    const verifyToken = async () => {
      const token = searchParams.get('token')
      if (!token) {
        setStatus('error')
        setMessage('No verification token provided')
        return
      }

      try {
        const res = await fetch(`${API_URL}/api/auth/verify-email?token=${token}`)
        const data = await res.json()

        if (res.ok) {
          setStatus('success')
          setMessage(data.message)
          
        } else {
          setStatus('error')
          setMessage(data.detail || 'Verification failed')
        }
      } catch (error) {
        setStatus('error')
        setMessage('Network error during verification')
        console.error('Verification error:', error)
      }
    }

    void verifyToken()
  }, [searchParams])

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: '#ffffff',
        padding: '48px',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '440px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        textAlign: 'center'
      }}>
        {status === 'loading' && (
          <>
            <div style={{
              width: '80px',
              height: '80px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              animation: 'spin 2s linear infinite'
            }}>
              <Mail size={40} color="#ffffff" />
            </div>
            <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1a202c', marginBottom: '12px' }}>
              Verifying Email
            </h2>
            <p style={{ fontSize: '16px', color: '#718096' }}>
              Please wait while we verify your email address...
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{
              width: '80px',
              height: '80px',
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px'
            }}>
              <CheckCircle size={40} color="#ffffff" />
            </div>
            <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1a202c', marginBottom: '12px' }}>
              Email Verified!
            </h2>
            <p style={{ fontSize: '16px', color: '#718096', marginBottom: '32px' }}>
              {message}
            </p>
            <Link
              to="/login"
              style={{
                display: 'inline-block',
                padding: '12px 32px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: '#ffffff',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '16px'
              }}
            >
              Go to Login
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{
              width: '80px',
              height: '80px',
              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px'
            }}>
              <AlertCircle size={40} color="#ffffff" />
            </div>
            <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1a202c', marginBottom: '12px' }}>
              Verification Failed
            </h2>
            <p style={{ fontSize: '16px', color: '#718096', marginBottom: '32px' }}>
              {message}
            </p>
            <Link
              to="/register"
              style={{
                display: 'inline-block',
                padding: '12px 32px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: '#ffffff',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '16px'
              }}
            >
              Try Again
            </Link>
          </>
        )}

        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  )
}
